export const WHITELIST_URL = 'https://966te8v5pwh.typeform.com/to/Iw5E8xYS';
export const PRESALE_END_DATE = '11/15/2022 13:00';
